import React from "react";
import PropTypes from "prop-types";
import "./topBar.scss";
import UserMenu from "./UserMenu";


const TopBar = ({ crumbs, onBack }) => (
    <header className="topbar">
      <nav className="tb-crumbs" aria-label="Breadcrumb">
        <button type="button" className="tb-back" aria-label="Back" onClick={onBack}>
          &#8249;
        </button>
        {crumbs.map((c, i) => (
          <React.Fragment key={c.label}>
            {i > 0 && <span className="tb-sep" aria-hidden="true">/</span>}
            {c.onClick ? (
              <button type="button" className="tb-crumb is-link" onClick={c.onClick}>
                {c.label}
              </button>
            ) : (
              <span className="tb-crumb is-current" aria-current="page">
                {c.label}
              </span>
            )}
          </React.Fragment>
        ))}
      </nav>

      <div className="tb-right">
        <UserMenu />
      </div>
  </header>
);

TopBar.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, onClick: PropTypes.func })
  ).isRequired,
  onBack: PropTypes.func.isRequired,
};

export default TopBar;
